import { Component, OnInit, Inject, Renderer2 } from '@angular/core';
import { AuthServices, AppServices, UserServices } from "@services";
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';

@Component({
    selector: 'app-loadingApp',
    templateUrl: './loadingApp.component.html',
    styleUrls: ['./loadingApp.component.scss']
})

export class LoadingAppComponent implements OnInit {

    isLoading = true;
    LoadingStatus = "";

    constructor(
        public translate: TranslateService,
        public renderer: Renderer2,
        private _dialogService: MatDialog,
        @Inject('AuthServices') private _authServices: AuthServices,
        @Inject('AppServices') private _appServices: AppServices,
        @Inject('UserServices') private _userServices: UserServices,
    ) { }

    ngOnInit() {
        // this.LoadingStatus = 'app.trn-starting-application'
        this.LoadingStatus = 'app.trn-starting-application';
        // console.log(this.translate.instant('app.trn-starting-application'))


        //Get all AppSetiings from Database and When Done then Start App
        setTimeout(() => {

            this._authServices.isPassExpired().subscribe((_isPassExpired) => {

                if (_isPassExpired == 'true') {
                    this.LoadingStatus = 'app.trn-process-resetting-password';
                    this.ResetPassword()
                } else {
                    this.LoadingStatus = 'app.trn-starting-application';
                    this.ProceedLoadingApp()
                }

            }, (_error) => {
                this._appServices.Logout();
            });

        }, 1000);

      


    }



    ResetPassword() {
        const _dialog = this._dialogService.open(ResetPasswordComponent, {
            disableClose: true,
            panelClass: 'csp-mat-full-screen-dialog',
            hasBackdrop: true,
            backdropClass: 'backdrop-modal-default',
        });
        _dialog.componentInstance.onPasswordReset.subscribe(() => {
            _dialog.close()
            this.ProceedLoadingApp()
        });
    }

    ProceedLoadingApp() {
 
        this._appServices._getAppSetting().subscribe((_UserData) => {

            this.LoadingStatus = 'app.trn-loading-settings';
            this._userServices.setLoggedInUser(_UserData);

            setTimeout(() => {
                this._appServices.applyAppSettings();
                this.LoadingStatus = 'app.trn-applying-settings';
                this._authServices._startAppHomePage();
            }, 1000);

        }, (_error) => {
            this._appServices.Logout();
        });

    }



}